module.exports = __webpack_public_path__ + "stylesheets/notifications_8f662b348103d33c454947b13aebf8b3.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/notifications.less
// module id = x+OW
// module chunks = 151